import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { DataTablesResponse } from '../../../../shared/models/datatables-response';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '../../../../shared/auth/authentication.service';
import { environment } from '../../../../../environments/environment'
import { ISalesDeals } from '../../../../shared/models/SalesDealListOutputModel';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { PropertyFor } from '../../../../shared/enum/enum';
import { ValidationService } from '../../../../shared/providers/validation.service';

enum views {
  DealList = 1,
  Offers = 2,
  Likes = 3,
  Views = 4,
  Inquiries = 5,
  OM = 6
}

@Component({
  selector: 'app-shared-deals-list',
  templateUrl: './shared-deals-list.component.html',
  styleUrls: ['./shared-deals-list.component.css']
})
export class SharedDealsListComponent implements OnInit {

  constructor(private http: HttpClient, public Authentication: AuthenticationService, private activatedRoute: ActivatedRoute, private router: Router, public Validation: ValidationService) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      let fromMenu = params['fromMenu'];
      if (fromMenu !== null && fromMenu !== undefined) {
        this.currentMenu = fromMenu;
      }
    });
  }
  dtOptions = {};
  IsLoading = false;
  table: DataTableDirective;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  protected readonly BASE_URL: string = environment.base_url;
  LoggedInUser: any;
  SalesDealsList: ISalesDeals[];
  haveaccesstoviewlocation: boolean = true;
  view = views;
  activeview = views.DealList;
  listType = ["deals-sale", "1031"];
  selectedSubTab = 1;
  selectedList = PropertyFor.Sale;
  propertyFor = PropertyFor;
  currentMenu = '';
  ngOnInit() {
    if (this.router.url.toLowerCase().includes("deals-sale")) {
      this.selectedList = PropertyFor.Sale;
    }
    else {
      this.selectedList = PropertyFor.Exchange1031;
    }
    if (!this.Authentication.Admin() && !this.Authentication.SuperAdmin() && !this.Authentication.Broker() && !this.Authentication.DataEntryStaff()) {
      this.haveaccesstoviewlocation = false;
    }
    else {
      this.haveaccesstoviewlocation = true;
    }
    this.bindTable();
  }
  Is1031 = false;
  @Input() sellerId = 0;
  @Input() parentPageId = 0;
  pageName = 'Deals';
  viewAsChild = false;
  bindTable() {
    const that = this;
    this.LoggedInUser = this.Authentication.user;
    this.viewAsChild = this.sellerId > 0;
    if (this.parentPageId == 1) {
      this.pageName = 'Seller Dashboard';
    }
    if (this.router.url.includes("deals-sale")) {
      this.Is1031 = false;
    }
    else {
      this.Is1031 = true;
    }
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "pageLength": 50,
      "order": [0, "asc"],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true;
        const filter =
        {
          UserId: this.sellerId == 0 ? this.LoggedInUser.Id : this.sellerId,
          LoggedInUserId: this.parentPageId == 1 ? this.LoggedInUser.Id : 0,
          PropertyFor: 0,//this.selectedList
          IsSeller: (this.sellerId > 0) || this.Authentication.Seller(),
          IsArchive: this.isArchive
        }
        dataTablesParameters.Extra_param = filter;

        const httpHeader = this.Validation.GetAuthHeader();
        that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/opportunity/salesdeallist/',
            dataTablesParameters, httpHeader
          ).subscribe(resp => {
            that.SalesDealsList = resp.data ? resp.data : [];
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            }
            else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            this.IsLoading = false;
          });
      },
      columns: [
        { data: 'PropertyName' },
        { data: 'State' },
        { data: 'Address' },
        { data: 'AskingPrice' },
        { data: 'BestOffer' },
        { data: 'RecentOffer' },
        { data: 'Offers' },
        { data: 'Offers1031' },
        { data: 'Likes' },
        { data: 'Views' },
        { data: 'Inquiries' },
        { data: 'OM' },
        { data: 'PropertyFor' }
      ]
    };
  }
  onSearch(text: string) {
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }

  isArchive: boolean = false;
  ArchiveTab(val) {
    this.selectedSubTab = val;
    this.isArchive = val == 1 ? false : true;
    this.dtElement.dtInstance.then(x => x.draw());
  }

  selectedPropertyGuid: string = "";
  subPageName = this.Authentication.Seller() ? "My Deals" : "Offers";
  onViewSelect(selectedView, guid, viewName?: string) {
    this.activeview = selectedView;
    this.selectedPropertyGuid = guid;
    if (selectedView === views.Inquiries) {
      //this.router.navigateByUrl('inquiry-list?property=' + guid + '&prevroute=Sales Deals List&link=' + this.router.url);
      this.router.navigateByUrl('viewproperty/' + guid + '?tab=inquiry&prevroute=' + this.pageName + '&link=' + encodeURIComponent(this.router.url));
    }
    else if (selectedView === views.Offers) {
      this.router.navigateByUrl('viewproperty/' + guid + '?tab=Offer&prevroute=' + this.pageName + '&link=' + encodeURIComponent(this.router.url));
    }
    else if (selectedView === views.OM) {
      this.router.navigateByUrl('viewproperty/' + guid + '?tab=Memorandom&prevroute=' + this.pageName + '&link=' + encodeURIComponent(this.router.url));
    }
    else {
      this.router.navigateByUrl('viewproperty/' + guid + '?prevroute=' + this.pageName + '&link=' + encodeURIComponent(this.router.url));
    }
    if (viewName) {
      this.subPageName = viewName;
    }
  }

  onBack(backView) {
    this.activeview = backView;
    this.selectedPropertyGuid = null;
    this.subPageName = "Deals";
  }
}
